import { RadioGroup as BaseRadioGroup } from "@base-ui-components/react/radio-group";
import { useRadioGroup, UseRadioGroupProps } from "./useRadioGroup";
import { labelClasses } from "@/Field/Field.style";
import { RadioGroupProvider } from "./RadioGroupContext";
import React from "react";
import { RadioIndexProvider } from "./RadioIndexContext";
import { Field } from "@base-ui-components/react/field";
import { Fieldset } from "@base-ui-components/react/fieldset";

export type RadioGroupProps = UseRadioGroupProps;

const RadioGroup = (props: RadioGroupProps) => {
  const { variant, getRadioGroupProps } = useRadioGroup(props);
  const { children, variantOptionLabel, label, ...rest } = getRadioGroupProps();

  // const { onChange } = props;

  return (
    <RadioGroupProvider
      variant={variant}
      variantOptionLabel={variantOptionLabel}
    >
      <Field.Root
        className="flex flex-col items-start gap-1 w-full mb-2"
        render={<Fieldset.Root />}
      >
        {label && (
          <Fieldset.Legend className={labelClasses()}>{label}</Fieldset.Legend>
        )}
        <BaseRadioGroup {...rest}>
          {React.Children.map(children, (child, index) => (
            <RadioIndexProvider key={index} index={index}>
              {child}
            </RadioIndexProvider>
          ))}
        </BaseRadioGroup>
        <Field.Description />
        <Field.Error />
      </Field.Root>
    </RadioGroupProvider>
  );
};

export default RadioGroup;
